import React, { useEffect, useState } from 'react';
import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';

const InstructorForm = () => {
  const [TenantOptions, setTenantOptions] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const userData = JSON.parse(localStorage.getItem('@SoilAnalysis:user'));
  const userTenantID = userData.tenantID;

  const activeOptions = [
    { value: true, text: 'Sim' },
    { value: false, text: 'Não' },
  ];

  const instructors = [
    {
      label: 'Nome',
      name: 'name',
      type: 'input',
      //disabled : isTenant,
    },
    {
      label: 'Código externo',
      name: 'externalCode',
      type: 'input',
      required: true,
    },
    {
      label: 'Empresa',
      name: 'tenantID',
      type: 'select',
      options: TenantOptions,
      visible: isVisible,
      required: true,
    },
    {
      label: 'Ativo',
      name: 'isActive',
      type: 'select',
      options: activeOptions,
    },
  ];

  const loadData = async () => {
    setIsVisible(true);

    Api.get('Tenant/getAllItems')
      .then(resultTenant => {
        if (resultTenant && resultTenant.data) {
          let options = resultTenant.data.response.map(item => ({
            value: item.tenantID,
            text: item.name,
          }));
          if (userTenantID == null) {
            options = [{ value: '', text: 'Selecione' }, ...options];
          } else {
            options = options.filter(opt => opt.value === userTenantID);
          }
          setTenantOptions(options);
        }
      })
      .catch(error => {
        exceptionNotificationAPI(error);
      });
  };

  useEffect(() => {
    loadData();
  }, []);

  return TenantOptions.length > 0 ? (
    <FormCrud
      formName={'instructor'}
      title={'Instrutor'}
      fields={instructors}
    />
  ) : (
    <></>
  );
};

export default InstructorForm;
